export function getThenBlock(setFn)  {
  return (res) => {
    setFn(res.data.data);
  }
}